import { FORM_METHOD_TYPES } from "../../stateCommon/consts";
import { tryEval } from '@tencent/ui-core/lib/utils/stringInterop';
import { getRuntimeMethod } from "./runtimeMethods";
/**
 * todo
 * @param args
 * @returns
 */
const getTryEval = (instance, args) => code => {
  const {
    renderer
  } = instance.options;
  return tryEval(code, renderer, {
    source: instance,
    args
  });
};
const getArgsMap = (argsArray, formInfo) => {
  const args = {};
  formInfo.args.forEach((item, index) => {
    args[String(item.id)] = argsArray[index];
  });
  return args;
};
const getFnParamsMap = {
  [FORM_METHOD_TYPES.init](params, tryEval) {
    const fnParams = {
      assign: [],
      invoke: []
    };
    params.assign.forEach(item => {
      const res = tryEval(item.code); // todo compute
      fnParams.assign.push({
        key: item.key,
        value: res
      });
    });
    params.invoke.filter(item => item.enabled).forEach(item => {
      var _item$args;
      const res = (_item$args = item.args) === null || _item$args === void 0 ? void 0 : _item$args.map(arg => tryEval(arg)); // todo compute
      fnParams.invoke.push({
        method: item.method,
        args: res || []
      });
    });
    return fnParams;
  },
  [FORM_METHOD_TYPES.request](params, tryEval) {
    const fnParams = ['request', 'codeKey', 'msgKey', 'succMsg'].reduce((prev, key) => {
      prev[key] = tryEval(params[key]);
      return prev;
    }, {});
    fnParams.showMsg = params.showMsg;
    fnParams.skipCode = params.skipCode;
    fnParams.excludeCgiMap = params.excludeCgiMap;
    return fnParams;
  }
};
export function getFormRuntimeMethod(instance, method) {
  const formInfo = method.formInfo;
  const {
    params,
    tpl
  } = formInfo;
  // 根据模板名获取运行时的方法
  const runtimeMethod = getRuntimeMethod(tpl);
  if (!runtimeMethod) {
    throw new Error(`runtimeMethod is not found template:${tpl}`);
  }
  // 两种表单的区别只有拿参数的方式不一样
  const getFnParams = getFnParamsMap[formInfo.type];
  const fn = async (...args) => {
    const argsMap = getArgsMap(args, formInfo);
    const tryEval = getTryEval(instance, argsMap);
    const fnParams = getFnParams(params, tryEval);
    const fnResult = await runtimeMethod.call(instance, fnParams, argsMap, {
      method,
      formInfo
    });
    return fnResult;
  };
  return fn;
}
//# sourceMappingURL=getFormRuntimeMethod.js.map
